import { useEffect } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  handleBeforeUnload,
  isDeviceAndroid,
  isDeviceIos
} from '@/modules/perseo-billing/utils/index';

const useBeforeUnload = () => {
  const {
    leavingPayment,
    isProcessingPayment,
    paymentSuccess,
    paymentError,
    cencoPayStatus,
    cencoPayQR
  } = useAppSelector((state) => state.billing);

  useEffect(() => {
    if (!leavingPayment) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    const hasCencopayStatus =
      cencoPayStatus !== undefined && cencoPayStatus !== null;
    if (
      hasCencopayStatus ||
      cencoPayQR ||
      paymentError ||
      isProcessingPayment ||
      paymentSuccess ||
      isDeviceAndroid() ||
      isDeviceIos()
    ) {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [
    leavingPayment,
    isProcessingPayment,
    paymentSuccess,
    paymentError,
    cencoPayStatus,
    cencoPayQR
  ]);
};

export default useBeforeUnload;
